const styles = {
  tableWrapper: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: 0,
    p: 0,
    borderRadius: 0,
  },
  tableContainerWrapper: {
    width: "100%",
    boxSizing: "border-box",
    p: 0,
    border: "15px solid #fff",
    borderRadius: 0,
    backgroundColor: "#fff",
    boxShadow: "none",
  },
  tableHeader: {
    borderBottom: "2px solid #5236AB",
  },
  tableHeaderCell: {
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    fontWeight: "bold",
    fontSize: "1rem",
    zIndex: 10,
    borderBottom: "2px solid #5236AB",
    py: 0.5,
    px: 2,    
  },
  tableRow: {},
  tableCell: {
    py: 0,
    borderBottom: "1px solid #ddd",
    fontSize: "0.88rem",
  },
  tableLink: {
    color: "#5236AB",
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
    fontSize: "0.88rem",
  },
  editIcon: {
    color: "#5236AB",
  },

  // Pagination styling
  paginationContainer: {
    p: 0.5, 
    backgroundColor: "transparent",
  },
  tablePagination: {
    backgroundColor: "transparent",

    "& .MuiTablePagination-toolbar, & .MuiToolbar-root": {
      minHeight: 28, 
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 4,
      paddingRight: 4,
      alignItems: "center",
    },

    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
      margin: 0,
      fontSize: "0.85rem",
      lineHeight: 1.3,
      display: "flex",
      alignItems: "center",
    },

    "& .MuiTablePagination-select, & .MuiInputBase-root": {
      fontSize: "0.85rem",
      lineHeight: 1.3,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      paddingTop: 2, 
      paddingBottom: 2,
      lineHeight: "normal",
    },

    "& .MuiTablePagination-actions": {
      margin: 0,
      padding: 0,
      display: "flex",
      alignItems: "center", 
    },
    "& .MuiTablePagination-actions .MuiIconButton-root": {
      padding: 1.5,
      minWidth: 28,
      minHeight: 24,
    },
  },

  compactActionButton: {
    p: 0,
    minWidth: "auto",
  },
};

export default styles;
